import React from 'react';
import { DragSource } from 'react-dnd';
import { ItemTypes } from '../constants';
import Highlightable from '../HOCs/Highlightable';
import flow from 'lodash.flow';

import styles from '../../../../stylesheet/css/header-builder/element.css';

const source = {
  beginDrag(props) {
    const { id, type, caption, options } = props;
    return { id, type, caption, options };
  },

  endDrag(props, monitor) {
    if (monitor.didDrop() && !monitor.getDropResult().droppedToTheSameColumn) {
      /**
       * calling props.onRemove(props.id) in not required,
       * because removing this element will be handled by
       * the target column.
       */
    }
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}

function getStyle(options, isDragging) {
  const { display = 'inline-block' } = options;

  return {
    display,
    ...(isDragging ? {
      opacity: 0
    } : {})
  };
}

const Element = ({ type, caption: defaultCaption, options = {},
  connectDragSource, isDragging,
  isHighlighted, onHighlight }) => {
  const { caption = defaultCaption, display = 'inline-block' } = options;

  let className = styles.element;

  if (isHighlighted) {
    className += ' ' + styles.highlighted;
  }

  const onDragStart = function (e) {
    const parentNode = e.target;
    parentNode.childNodes[0].style.display = 'none';
  }

  const onMouseUp = function (e) {
    e.target.childNodes[0].style.display = 'inline-block';
  }

  return connectDragSource(
    <span
    style={getStyle(options, isDragging)}
    className={className}
    onClick={onHighlight}
    onDragStart={onDragStart}>
      <i className={styles.label}>{caption}</i>
      {caption}
    </span>
  );
};

export const ElementDropPreview = () => (
  <div style={{ display: 'inline-block' }}
    className={styles.element + ' ' + styles.dropPreview}>
    &nbsp;
  </div>
);

export default flow(
  DragSource(ItemTypes.ELEMENT, source, collect),
  Highlightable()
)(Element);



// WEBPACK FOOTER //
// ./app/header-builder/components/Element.js